export default {
    init() {
        let tabanchor = [];

        $( '.client-categorie-list-name' ).each(function() {
            tabanchor.push($(this).attr('data-filter'));
        });

        tabanchor.forEach(function(x) {
            if(window.location.hash == '#all') {
                $('.client-categorie-list-name.all').addClass('active');
                $('.client-card.all').css('display', 'block');
            } else if(window.location.hash == '#' + x) {
                $('.client-categorie-list-name.all').removeClass('active');
                $('.client-categorie-list-name.' + x).addClass('active');
                $('.client-card').css('display', 'none');
                $('.client-card.' + x).css('display', 'block');
            }
            $('.client-categorie-list-name.' + x).click(function () {
                window.location.hash = x;
            });
        })


    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/client.js